<template>
  <div
    class="modalBlock"
    :class="{ 'modalBlock-hasBackgroundImage': hasBackgroundImage }"
  >
    <StageBorder></StageBorder>
    <div class="modalHeaderBlock">
      <div class="headerTitle">
        {{
          getTranslation($store, "Product", "display_name", item.id, item.name)
        }}
      </div>
      <div>
        <ingredient-image-composition
          v-if="hasComposerPositionData"
          :product="item"
          :compositionImageGroups="compositionImageGroups"
        ></ingredient-image-composition>
        <img v-else class="headerImg" :src="item.image" />
      </div>
      <div
        class="yellowCircle"
        :class="[showCircleBackground ? 'yellowCircle-hasBackgroundImage' : '']"
      ></div>
    </div>
    <div class="ingredientSelectorWrapper">
      <IngredientSelector
        :product="item"
        :isEdit="isEdit"
        :isEditIngredientLayer="isEditIngredientLayer"
        :disableProceed="!enableNext"
        :seenAllTabs="seenAllTabs"
        @change="changeIngredient"
        @proceed="goNext"
        @back="back"
        limited
        @tabChanged="ingredientSelectorTabChanged"
        @composerPositionData="handleComposerPositionData"
        ref="ingredientSelector"
      ></IngredientSelector>
    </div>
    <bottom-nav
      @proceed="goToOrder"
      @onClose="onClose"
      :show-total-container="true"
      :show-scan-and-go="false"
      :show-submit="true"
      :item="item"
      :disableProceed="true"
      >{{ $t("menu.footer.complete_order") }}</bottom-nav
    >
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { toCalculatable, toPrintable } from "@/utils/pricing";
import {
  createNewObject,
  getPopulatedIngredientGroups
} from "@/utils/products";
import { xor } from "lodash";
import { getTranslation, isBackgroundImageSet } from "@/utils/helpers";

import IngredientSelector from "./common/ingredientSelector";
import IngredientImageComposition from "@/components/common/IngredientImageComposition";
import BottomNav from "@/components/BottomNav";
import StageBorder from "@/components/common/StageBorder";
import { generateCompositionImageGroups } from "@/utils/compositionImageUtil";
import {
  selectionValid,
  setBreadcrumbData,
  getFirstIngredientGroupId,
  isFirstBreadcrumbItemActive,
  getPrevious
} from "@/utils/ingredientWizard";

export default {
  components: {
    IngredientImageComposition,
    IngredientSelector,
    BottomNav,
    StageBorder
  },
  props: {
    product: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    isEditIngredientLayer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      item: {},
      enableNext: false,
      seenAllTabs: false,
      seen: [],
      igs: [],
      currentIngredientGroupId: null,
      breadcrumbData: [],
      hasComposerPositionData: false,
      compositionImageGroups: []
    };
  },
  created() {
    this.item = createNewObject(this.product);
    this.igs = getPopulatedIngredientGroups(this.item);
    this.currentIngredientGroupId = getFirstIngredientGroupId(this.igs);
    this.breadcrumbData = setBreadcrumbData(
      this.igs,
      this.currentIngredientGroupId
    );
  },
  computed: {
    ...mapGetters({
      basket: "BASKET"
    }),
    showCircleBackground() {
      return isBackgroundImageSet(
        "--component_ingredientWizard_yellowCircle_background-image"
      );
    },
    hasBackgroundImage() {
      return isBackgroundImageSet(
        "--component_ingredientWizard_modalBlock_background-image"
      );
    }
  },

  methods: {
    ...mapActions({ logAudit: "LOG_AUDIT" }),
    getTranslation,
    toCalculatable,
    toPrintable,
    setCompositionImageGroups: function() {
      console.log("setCompositionImageGroups");
      this.compositionImageGroups = generateCompositionImageGroups(this.item);
    },
    changeIngredient({ group, ingredient, count }) {
      console.log("changeIngredient (wizard)", group, ingredient, count);
      let groupName = group.id === -1 ? "default" : "" + group.id;
      let ing = this.item.ingredients[groupName].find(
        i => i.id === ingredient.id
      );

      if (ing) {
        ing.count = count;
      }
      this.setCompositionImageGroups();

      this.enableNext = true;
    },
    goBack() {
      let previousItem = getPrevious(
        this.breadcrumbData,
        this.currentIngredientGroupId
      );
      if (previousItem && previousItem.id) {
        console.log("previousId: " + previousItem.id);
        this.$refs.ingredientSelector.switchToId(previousItem.id);
      } else {
        console.log("Error: previousItem not found.");
      }
    },
    goNext() {
      let must_see = this.igs
        .filter(ig => ig.offer_options_to_user)
        .map(ig => ig.id);
      let need_to_see = xor(must_see, this.seen);
      if (need_to_see.length === 0) {
        this.saveItem();
      } else {
        this.$refs.ingredientSelector.switchToId(need_to_see[0]);
      }
    },
    saveItem() {
      this.$emit("onConfirm", this.item.ingredients);
    },
    back() {
      if (isFirstBreadcrumbItemActive(this.breadcrumbData)) {
        console.log("Back clicked for first item, closing wizard.");
        this.$emit("onClose");
      } else {
        //goto breadcrumb state
        this.goBack();
      }
    },
    onClose() {
      this.$emit("onClose");
    },
    goToOrder() {
      if (this.basket.length !== 0) {
        this.logRouter({ name: "order", router: this.$router });
      }
    },
    handleComposerPositionData(hasComposerPositionData) {
      console.log(
        "handleComposerPositionData hasComposerPositionData: " +
          hasComposerPositionData
      );
      this.hasComposerPositionData = hasComposerPositionData;
    },
    addIngredientGroupToSeen(ig) {
      if (!this.seen.find(id => id === ig.id)) {
        this.seen.push(ig.id);
      }
    },
    removeIngredientGroupFromSeen(ig) {
      this.seen = this.seen.filter(seenItem => seenItem !== ig.id);
    },
    ingredientSelectorTabChanged(ingredient_group) {
      if (selectionValid(ingredient_group)) {
        this.addIngredientGroupToSeen(ingredient_group);
      } else {
        this.removeIngredientGroupFromSeen(ingredient_group);
      }
      this.currentIngredientGroupId = ingredient_group.id;
      this.breadcrumbData = setBreadcrumbData(
        this.igs,
        this.currentIngredientGroupId
      );
      let must_see = this.igs
        .filter(ig => ig.offer_options_to_user)
        .map(ig => ig.id);
      let need_to_see = xor(must_see, this.seen);
      if (need_to_see.length === 0) this.seenAllTabs = true;
      this.enableNext = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.modalBlock {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 1080px;
  height: 1920px;
  background: var(--component_ingredientWizard_modalBlock_background);
  &-hasBackgroundImage {
    background-image: var(
      --component_ingredientWizard_modalBlock_background-image
    );
  }
}
.modalHeaderBlock {
  display: flex;
  justify-content: flex-start;
  height: var(--component_ingredientWizard_modalHeaderBlock_height);
  align-items: center;
  flex-direction: column;
  /*todo add variable for background image see fresh factory*/
  background: var(--component_ingredientWizard_modalHeaderBlock_background);
  background-image: var(
    --component_ingredientWizard_modalHeaderBlock_background-image
  );
}
.headerTitle {
  font-family: var(--component_ingredientWizard_headerTitle_font-family);
  font-size: var(--component_ingredientWizard_headerTitle_font-size);
  letter-spacing: 0;
  color: var(--component_ingredientWizard_headerTitle_color);
  margin: var(--component_ingredientWizard_headerTitle_margin);
  text-align: center;
  text-transform: var(--component_ingredientWizard_headerTitle_text-transform);
  text-shadow: var(--component_ingredientWizard_headerTitle_text-shadow);
  top: var(--component_ingredientWizard_headerTitle_top);
  transform: var(--component_ingredientWizard_headerTitle_transform);
  position: absolute;
  z-index: 20;
}
.headerImg {
  height: 330px;
  position: absolute;
  top: var(--component_ingredientWizard_headerImg_top);
  left: 0;
  right: 0;
  z-index: 20;
  margin: var(--component_ingredientWizard_headerImg_margin);
}

.yellowCircle {
  position: absolute;
  top: -420px;
  left: 63px;
  width: var(--component_ingredientWizard_yellowCircle_width);
  height: var(--component_ingredientWizard_yellowCircle_height);
  border-radius: 50%;
  background: var(--component_ingredientWizard_yellowCircle_background);

  &-hasBackgroundImage {
    background-image: var(
      --component_ingredientWizard_yellowCircle_background-image
    );
    background-position: center;
    background-size: var(
      --component_ingredientWizard_yellowCircle_background-size
    );
    background-repeat: no-repeat;
  }
}

.ingredientSelectorWrapper {
  height: var(--component_ingredientWizard_ingredientSelectorWrapper_height);
  margin: var(--component_ingredientWizard_ingredientSelectorWrapper_margin);
}

.actionBlock {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  position: absolute;
  bottom: 30px;
}
.headerSave {
  font-family: var(--app_font-family-light);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  width: 210px;
  height: 70px;
  border: none;
  border-radius: 35px;
  color: white;
  outline: none;
}
.headerSave:disabled {
  filter: saturate(0);
}
.closeBtn {
  width: 210px;
  height: 70px;
  border-radius: 35px;
  font-family: var(--app_font-family-light);
  border: var(--app_button-outlined_border-width) solid #f39a00;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}
.comboHeader {
  color: #252525;
  font-size: 26px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
}
.productBlock {
  justify-content: center;
  display: flex;
  margin-top: 50px;
}
</style>
